import { H7 } from '../Typography';

import { BadgeContainer, fontColors } from './styles';
import { BadgeProps } from './types';

const Badge: React.FC<BadgeProps> = ({
  text,
  round = 'full',
  size = 's',
  variant = 'main',
  maxWidth = '270px',
  textStrikeThrough = false,
}) => {
  return (
    <BadgeContainer
      maxWidth={maxWidth}
      round={round}
      size={size}
      textStrikeThrough={textStrikeThrough}
      variant={variant}
    >
      <H7 noTextOverflow color={fontColors[variant]}>
        <b>{text}</b>
      </H7>
    </BadgeContainer>
  );
};

export default Badge;
